import { Switch } from "antd";
import React, { useEffect } from "react";
import { SyncOutlined } from "@ant-design/icons";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { autoRefreshInProgressAudios, switchInProgressAutoFresh } from "../../../redux/JobModule/InProgressPage/InProgressAction";

function AutoRefreshInProgressCheckbox(props: any) {
  const dispatch = useAppDispatch();
  const autoRefreshState = useSelector((state: RootState) => state.InProgressAudiosState.autoRefreshInProgressState);
  useEffect(() => {
    dispatch(autoRefreshInProgressAudios({}));
  }, [autoRefreshState.autoRefresh]);
  return null;
  // (
  //   <div className="auto-refresh-checkbox h-100 gap-2 ">
  //     <SyncOutlined
  //       style={{
  //         fontSize: 15,
  //         visibility: autoRefreshState.loading ? "visible" : "hidden",
  //       }}
  //       spin
  //     />
  //     <Switch
  // style={{ margin:"11px",fontSize:"15px",boxShadow:"none"}}
  //       size="default"
  //       defaultChecked={autoRefreshState.autoRefresh}
  //       onChange={(checked) => {
  //         dispatch(switchInProgressAutoFresh({ autoRefresh: checked }));
  //       }}
  //     />

  //     <span>Auto Refresh</span>
  //   </div>
  // );
}

export default AutoRefreshInProgressCheckbox;
